import $ from "jquery";
export const SubMenu = () => {

    $(".main-menu__nav-item").hover(function() {
        $(this).find(".sub-menu-wraper").fadeIn("fast");
    });
    $(".main-menu__nav-item").mouseleave(function() {
        $(this).find(".sub-menu-wraper").fadeOut();
    });
};